import React from 'react';
import { Lock, Gift, ShieldCheck } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

export default function TopBar() {
  const { t } = useTranslation();
  const MESSAGES = [
    { icon: Lock, text: t('topbar.paiement') },
    { icon: Gift, text: t('topbar.livraison') },
    { icon: ShieldCheck, text: t('topbar.garantie') }
  ];
  // Duplicate multiple times for a seamless infinite loop
  const items = [...MESSAGES, ...MESSAGES, ...MESSAGES, ...MESSAGES, ...MESSAGES, ...MESSAGES];
  return (
    <div className="w-full bg-black text-white text-[10px] md:text-[11px] tracking-luxury uppercase overflow-hidden border-b border-black">
      <div className="relative py-2.5">
        <div className="flex whitespace-nowrap animate-marquee">
          {items.map((m, i) => (
            <div key={i} className="flex items-center gap-2 px-6 md:px-10">
              <m.icon className="w-3.5 h-3.5" strokeWidth={1.5} />
              <span>{m.text}</span>
              <span className="ml-6 md:ml-10 opacity-40">•</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
